import React, {
  ForwardedRef,
  PropsWithoutRef,
  ReactElement,
  RefAttributes,
} from "react";

// needed to preserve generics due to https://github.com/DefinitelyTyped/DefinitelyTyped/issues/37087
export const typedMemo: <T>(c: T) => T = React.memo;

export const typedForwardRef = <P, T>(
  render: (props: P, ref: ForwardedRef<T>) => ReactElement | null,
): ((props: PropsWithoutRef<P> & RefAttributes<T>) => ReactElement | null) =>
  React.forwardRef(render);
